import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { env } from '../env';

let reactPlugin: ReactPlugin | null = null;
let appInsights: ApplicationInsights | null = null;

/**
 * Create the App Insights Telemetry Service
 * @return {{reactPlugin: ReactPlugin, appInsights: Object, initialize: Function}} - Object
 */
const createTelemetryService = () => {
    /**
     * Initialize the Application Insights class
     * @return {void}
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const initialise = (instrumentationKey: string): void => {
        reactPlugin = new ReactPlugin();
        appInsights = new ApplicationInsights({
            config: {
                // connectionString: 'YOUR_CONNECTION_STRING_GOES_HERE',
                instrumentationKey,
                disablePageUnloadEvents: ['unload'],
                enableAutoRouteTracking: true,
                extensions: [reactPlugin],
            },
        });
        appInsights!.loadAppInsights();
    };
    const instrumentationKey = env.REACT_APP_APPINSIGHTS_INSTRUMENTATIONKEY ?? 'dummy_key';
    initialise(instrumentationKey);

    return { reactPlugin, appInsights };
};

export const ai = createTelemetryService();
export const getAppInsights = () => appInsights;
